export const UNSAVED_CONFIRM_MESSAGE = '저장되지 않은 작업이 있습니다.\n계속하시겠습니까?';
